var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_447_1",
    "data-name": "Component 447 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #707070;\n        stroke: #707070;\n        stroke-miterlimit: 10;\n        stroke-width: .25px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7744",
    "data-name": "Rectangle 7744",
    className: "cls-1",
    y: 0,
    width: 32,
    height: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.62,13.28h7.65v-7.65h-1.4v4.85c-.94-1.53-2.19-2.72-3.74-3.58-1.55-.85-3.22-1.28-5-1.28-2.91,0-5.37,1.01-7.38,3.02-2.01,2.01-3.02,4.46-3.02,7.36s1.01,5.35,3.02,7.36c2.01,2.01,4.47,3.01,7.38,3.01,2.31,0,4.38-.68,6.21-2.03,1.83-1.35,3.08-3.13,3.73-5.34h-1.48c-.63,1.8-1.72,3.24-3.26,4.34-1.54,1.09-3.28,1.64-5.19,1.64-2.5,0-4.63-.87-6.38-2.62-1.75-1.75-2.62-3.86-2.62-6.35s.87-4.61,2.62-6.36c1.75-1.75,3.88-2.62,6.38-2.62,1.69,0,3.24.43,4.66,1.3,1.42.87,2.52,2.05,3.3,3.56h-5.48v1.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.f5c1703740a8ea242563d8d54ff7e89f.svg";
export { ForwardRef as ReactComponent };